import { call, put } from 'redux-saga/effects';
import { setBancos, savedBanco } from '../../ducks/bancos';
import { requestLoadBancos, requestSaveBanco } from '../requests/bancos';

export function* handleLoadBancos() {
    try {
        const response = yield call(requestLoadBancos);
        const { data } = response;
        yield put(setBancos(data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveBanco(action) {
    try {
        const response = yield call(requestSaveBanco, action.banco);
        const { data } = response;
        yield put(savedBanco(data));
    } catch (error) {
        console.log(error);
    }
}
